import LogoMark from "@/components/ui/LogoMark";
import { cn } from "@/lib/utils";

/**
 * Full Reformity wordmark + tagline + icon.
 *   <LogoFull theme="dark" />   // for dark backgrounds (white text)
 *   <LogoFull theme="light" />  // for light backgrounds (charcoal text)
 */
const LogoFull = ({ theme = "light", className = "" }) => {
    const dark = theme === "dark";
    const textColor = dark ? "text-white" : "text-brand-dark";
    const dimColor = dark ? "text-white/70" : "text-brand-dark/70";
    const dashColor = dark ? "bg-white/40" : "bg-brand-dark/40";
    return (
        <div className={cn("inline-flex items-center gap-3", className)}>
            <LogoMark className="h-12 w-auto shrink-0" title="Reformity Inc. logo" />
            <div className="flex flex-col leading-none">
                <span
                    className={cn(
                        "font-sans font-bold text-2xl md:text-3xl tracking-tight",
                        textColor,
                    )}
                >
                    Reformity Inc.
                </span>
                <span className="mt-1.5 flex items-center gap-2">
                    <span className={cn("inline-block h-[1.5px] w-4", dashColor)} aria-hidden="true" />
                    <span
                        className={cn(
                            "font-sans font-medium uppercase tracking-[0.18em] text-[10px]",
                            dimColor,
                        )}
                    >
                        To Reform &amp; Build
                    </span>
                    <span className={cn("inline-block h-[1.5px] w-4", dashColor)} aria-hidden="true" />
                </span>
            </div>
        </div>
    );
};

export default LogoFull;
export { LogoFull };
